import { useState, useEffect } from 'react';

// Allows you to trigger a callback after a state update. The callback is invoked with the updated
// version of the state after it changes.
// From https://www.robinwieruch.de/react-usestate-callback
export function useStateWithCallback<State>(
    initialState: State,
    callback: (updatedState: State) => void,
): [State, SetState<State>] {
    const [state, setState] = useState(initialState);

    useEffect(() => callback(state), [state, callback]);

    return [state, setState];
}
